export enum MultiViewComponentType {
	Split,
	Toggled,
	Radio
}
